import { render, staticRenderFns } from "./setAccount.vue?vue&type=template&id=26a06266&scoped=true"
import script from "./setAccount.vue?vue&type=script&lang=js"
export * from "./setAccount.vue?vue&type=script&lang=js"
import style0 from "./setAccount.vue?vue&type=style&index=0&id=26a06266&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a06266",
  null
  
)

export default component.exports